import { Achievement } from "../../types";

interface Props {
  data: Achievement[];
  className?: string;
}

export const AchievementRow = ({ data, className }: Props) => {
  if (!data) return null;

  return (
    <div
      tw="flex w-full h-16 border-t border-b border-solid border-gray"
      className={className}
    >
      {data.map((row, index) => (
        <div key={index} tw="flex-1 h-full flex items-center">
          {index !== 0 && (
            <div tw="border-l border-solid border-gray w-[1px] h-4/6" />
          )}
          <div tw="flex flex-col items-center w-full">
            <div tw="font-base text-[11px] tracking-[.27px] leading-[11px] text-theme">
              {row.title}
            </div>
            <div tw="mt-2 flex items-end">
              <div tw="font-base font-bold text-lg leading-[18px] tracking-[.45px]">
                {row.value}
              </div>
              <div tw="font-base text-[11px] tracking-[.27px] ml-0.5">
                {row.unit}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
